import { Component, input } from '@angular/core';
import { AppCommonModule } from 'src/app/common.module';

@Component({
  selector: 'app-quick-links-card',
  templateUrl: './quick-links-card.component.html',
  styleUrls: ['./quick-links-card.component.scss'],
  imports: [AppCommonModule],
})
export class QuickLinksCardComponent {
  title = input('nav.quickLinks');
}

